import {createTheme} from '@mui/material';
import type {} from '@mui/x-date-pickers/themeAugmentation';

declare module '@mui/material/styles' {
    interface Theme {
    }
    // allow configuration using `createTheme`
    interface ThemeOptions {
    }
}

const white = '#FFFFFF';

export const theme = createTheme(
    {
        palette: {
            primary: {
                contrastText: white,
                dark: '#004a56',
                main: '#006a7c',
                light: '#338796',
            },
            secondary: {
                contrastText: white,
                dark: '#b26b00',
                main: '#ff9900',
                light: '#ffad33',
            },
        },
        typography: {
            h1: {
                fontSize: '2rem',
                '@media (min-width: 420px)': {
                    fontSize: '3rem',
                },
            },
            h2: {
                fontSize: '1.7rem',
                '@media (min-width: 420px)': {
                    fontSize: '2.5rem',
                },
            },
            h3: {
                fontSize: '1.5rem',
                '@media (min-width: 420px)': {
                    fontSize: '2.1rem',
                },
            },
            h4: {
                fontSize: '1.3rem',
                '@media (min-width: 420px)': {
                    fontSize: '1.7rem',
                },
            },
            h5: {
                fontSize: '1.2rem',
                '@media (min-width: 420px)': {
                    fontSize: '1.4rem',
                },
            },
            h6: {
                fontSize: '1.1rem',
                '@media (min-width: 420px)': {
                    fontSize: '1.2rem',
                },
            },
        },
        components: {
        },
    },
);
